import { JsonObject, JsonProperty } from 'json2typescript';

/**
 * å»é¢éç½®
 */
@JsonObject
export class TenantSyncConfig {
  /**
   * ä¸»é®ID
   */
  @JsonProperty('id', Number)
  id: number = undefined;

  /**
   * æ¯å¦åæ­¥åå»ç½
   */
  @JsonProperty('syncHuayi', Boolean)
  syncHuayi: boolean = undefined;

  /**
   * æ¯å¦å¼å¯å¯¹æ¥è®¾ç½®ï¼ç§»å¨å»ç)
   */
  @JsonProperty('openYdylClient', Boolean)
  openYdylClient: boolean = undefined;

  /**
   * æ¯å¦å¼å¯ç§»å¨å»çæ°æ®åæ­¥å¯¹æ¥
   */
  @JsonProperty('dataSyncYdyl', Boolean)
  dataSyncYdyl: boolean = undefined;

  /**
   * æ¯å¦åè®¸ç§»å¨å»çå é¤é¨é¨
   */
  @JsonProperty('allowYdylDeleteDept', Boolean)
  allowYdylDeleteDept: boolean = undefined;
}
